"use strict";Object.defineProperty(exports, "__esModule", {value: true});// Code generated by scripts/generate-phone-registry.mjs from config/phone/supported_countries.json; DO NOT EDIT.

























 const DEFAULT_PHONE_CALLING_CODE = '1'; exports.DEFAULT_PHONE_CALLING_CODE = DEFAULT_PHONE_CALLING_CODE

 const SUPPORTED_PHONE_COUNTRIES = [
  {
    countryCode: 'CA',
    callingCode: '1',
    name: 'Canada',
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '(415) 903-1200',
    formatGroups: [3, 3, 4],
    formatStyle: 'nanp',
  },
  {
    countryCode: 'MX',
    callingCode: '52',
    name: 'Mexico',
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '415 903 1200',
    formatGroups: [3, 3, 4],
    formatStyle: 'spaced',
  },
  {
    countryCode: 'PR',
    callingCode: '1',
    name: 'Puerto Rico',
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '(415) 903-1200',
    formatGroups: [3, 3, 4],
    formatStyle: 'nanp',
  },
  {
    countryCode: 'US',
    callingCode: '1',
    name: 'United States',
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '(415) 903-1200',
    formatGroups: [3, 3, 4],
    formatStyle: 'nanp',
  },
]; exports.SUPPORTED_PHONE_COUNTRIES = SUPPORTED_PHONE_COUNTRIES

 const SUPPORTED_PHONE_COUNTRY_CODES = exports.SUPPORTED_PHONE_COUNTRIES.map(c => c.countryCode); exports.SUPPORTED_PHONE_COUNTRY_CODES = SUPPORTED_PHONE_COUNTRY_CODES

 const SUPPORTED_PHONE_CALLING_CODE_OPTIONS = [
  {
    callingCode: '1',
    compactLabel: '+1',
    menuLabel: 'U.S. / Canada / Puerto Rico (+1)',
    countryCodes: ['US', 'CA', 'PR'],
    countryNames: ['United States', 'Canada', 'Puerto Rico'],
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '(415) 903-1200',
    formatGroups: [3, 3, 4],
    formatStyle: 'nanp',
  },
  {
    callingCode: '52',
    compactLabel: '+52',
    menuLabel: 'Mexico (+52)',
    countryCodes: ['MX'],
    countryNames: ['Mexico'],
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '415 903 1200',
    formatGroups: [3, 3, 4],
    formatStyle: 'spaced',
  },
]; exports.SUPPORTED_PHONE_CALLING_CODE_OPTIONS = SUPPORTED_PHONE_CALLING_CODE_OPTIONS

 const SUPPORTED_PHONE_CALLING_CODES = Array.from(
  new Set(exports.SUPPORTED_PHONE_COUNTRIES.map(c => c.callingCode)),
).sort((a, b) => b.length - a.length || a.localeCompare(b)); exports.SUPPORTED_PHONE_CALLING_CODES = SUPPORTED_PHONE_CALLING_CODES

// Wider list for 2FA by invitees and existing org members. The server decides
// which list applies; every other phone field uses the SUPPORTED_ lists above.
 const INVITEE_PHONE_COUNTRIES = [
  {
    countryCode: 'AR',
    callingCode: '54',
    name: 'Argentina',
    minNationalDigitCount: 11,
    nationalDigitCount: 11,
    placeholder: '9 11 2345 6789',
    formatGroups: [1, 2, 4, 4],
    formatStyle: 'spaced',
  },
  {
    countryCode: 'CA',
    callingCode: '1',
    name: 'Canada',
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '(415) 903-1200',
    formatGroups: [3, 3, 4],
    formatStyle: 'nanp',
  },
  {
    countryCode: 'CO',
    callingCode: '57',
    name: 'Colombia',
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '321 1234567',
    formatGroups: [3, 7],
    formatStyle: 'spaced',
  },
  {
    countryCode: 'DE',
    callingCode: '49',
    name: 'Germany',
    minNationalDigitCount: 10,
    nationalDigitCount: 11,
    placeholder: '1512 3456789',
    formatGroups: [4, 7],
    formatStyle: 'spaced',
  },
  {
    countryCode: 'GB',
    callingCode: '44',
    name: 'United Kingdom',
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '7400 123456',
    formatGroups: [4, 6],
    formatStyle: 'spaced',
  },
  {
    countryCode: 'IN',
    callingCode: '91',
    name: 'India',
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '81234 56789',
    formatGroups: [5, 5],
    formatStyle: 'spaced',
  },
  {
    countryCode: 'MX',
    callingCode: '52',
    name: 'Mexico',
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '415 903 1200',
    formatGroups: [3, 3, 4],
    formatStyle: 'spaced',
  },
  {
    countryCode: 'PH',
    callingCode: '63',
    name: 'Philippines',
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '917 123 4567',
    formatGroups: [3, 3, 4],
    formatStyle: 'spaced',
  },
  {
    countryCode: 'PR',
    callingCode: '1',
    name: 'Puerto Rico',
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '(415) 903-1200',
    formatGroups: [3, 3, 4],
    formatStyle: 'nanp',
  },
  {
    countryCode: 'US',
    callingCode: '1',
    name: 'United States',
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '(415) 903-1200',
    formatGroups: [3, 3, 4],
    formatStyle: 'nanp',
  },
]; exports.INVITEE_PHONE_COUNTRIES = INVITEE_PHONE_COUNTRIES

 const INVITEE_PHONE_COUNTRY_CODES = exports.INVITEE_PHONE_COUNTRIES.map(c => c.countryCode); exports.INVITEE_PHONE_COUNTRY_CODES = INVITEE_PHONE_COUNTRY_CODES

 const INVITEE_PHONE_CALLING_CODE_OPTIONS = [
  {
    callingCode: '1',
    compactLabel: '+1',
    menuLabel: 'U.S. / Canada / Puerto Rico (+1)',
    countryCodes: ['US', 'CA', 'PR'],
    countryNames: ['United States', 'Canada', 'Puerto Rico'],
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '(415) 903-1200',
    formatGroups: [3, 3, 4],
    formatStyle: 'nanp',
  },
  {
    callingCode: '44',
    compactLabel: '+44',
    menuLabel: 'United Kingdom (+44)',
    countryCodes: ['GB'],
    countryNames: ['United Kingdom'],
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '7400 123456',
    formatGroups: [4, 6],
    formatStyle: 'spaced',
  },
  {
    callingCode: '49',
    compactLabel: '+49',
    menuLabel: 'Germany (+49)',
    countryCodes: ['DE'],
    countryNames: ['Germany'],
    minNationalDigitCount: 10,
    nationalDigitCount: 11,
    placeholder: '1512 3456789',
    formatGroups: [4, 7],
    formatStyle: 'spaced',
  },
  {
    callingCode: '52',
    compactLabel: '+52',
    menuLabel: 'Mexico (+52)',
    countryCodes: ['MX'],
    countryNames: ['Mexico'],
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '415 903 1200',
    formatGroups: [3, 3, 4],
    formatStyle: 'spaced',
  },
  {
    callingCode: '54',
    compactLabel: '+54',
    menuLabel: 'Argentina (+54)',
    countryCodes: ['AR'],
    countryNames: ['Argentina'],
    minNationalDigitCount: 11,
    nationalDigitCount: 11,
    placeholder: '9 11 2345 6789',
    formatGroups: [1, 2, 4, 4],
    formatStyle: 'spaced',
  },
  {
    callingCode: '57',
    compactLabel: '+57',
    menuLabel: 'Colombia (+57)',
    countryCodes: ['CO'],
    countryNames: ['Colombia'],
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '321 1234567',
    formatGroups: [3, 7],
    formatStyle: 'spaced',
  },
  {
    callingCode: '63',
    compactLabel: '+63',
    menuLabel: 'Philippines (+63)',
    countryCodes: ['PH'],
    countryNames: ['Philippines'],
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '917 123 4567',
    formatGroups: [3, 3, 4],
    formatStyle: 'spaced',
  },
  {
    callingCode: '91',
    compactLabel: '+91',
    menuLabel: 'India (+91)',
    countryCodes: ['IN'],
    countryNames: ['India'],
    minNationalDigitCount: 10,
    nationalDigitCount: 10,
    placeholder: '81234 56789',
    formatGroups: [5, 5],
    formatStyle: 'spaced',
  },
]; exports.INVITEE_PHONE_CALLING_CODE_OPTIONS = INVITEE_PHONE_CALLING_CODE_OPTIONS

 const INVITEE_PHONE_CALLING_CODES = Array.from(
  new Set(exports.INVITEE_PHONE_COUNTRIES.map(c => c.callingCode)),
).sort((a, b) => b.length - a.length || a.localeCompare(b)); exports.INVITEE_PHONE_CALLING_CODES = INVITEE_PHONE_CALLING_CODES
